const userActionTypes = {
  SET_DELEGATE_USER: "SET_DELEGATE_USER",
  SET_DELEGATE_USER_LOADING: "SET_DELEGATE_USER_LOADING",
  DELETE_DELEGATE_USER: "DELETE_DELEGATE_USER",
  SET_DELEGATE_USER_ID: "SET_DELEGATE_USER_ID",
  SET_PERSONAL_DATA: "SET_PERSONAL_DATA",
};

export default userActionTypes;
